import { Link } from '@remix-run/react';

const KeyBenefitsTwo = () => {
	return (
		<section className="container-lp mx-auto flex flex-wrap items-center justify-center md:mt-10">
			<div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 pb-12 pt-10 md:pb-20">
				<h2 className="text-transparent mx-auto bg-clip-text text-center text-3xl font-extrabold lg:text-5xl lg:leading-[60px]">
					<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
						Running a successful ecommerce business has never been so{' '}
					</span>
					<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
						easy and inexpensive
					</span>
				</h2>

				<div className="mx-auto max-w-[350px] text-center text-lg text-white md:max-w-full lg:text-xl">
					Your store doesn't need to be a time and money sink. PagePilot.ai is built to speed things up while saving you
					money.
				</div>
			</div>

			<div className="grid w-full grid-cols-2 gap-6 md:grid-cols-4">
				<div className="card-bg flex w-full flex-col gap-4 rounded-lg px-4 py-10">
					<img
						src="/images/landingpage/multiLanguage.svg"
						className="mx-auto w-full max-w-[65px]"
						alt="DropshippingMulti Languages Supported"
						width="65"
						height="65"
					/>
					<div className="mx-auto max-w-[225px] text-center font-bold text-white sm:text-xl">
						Multi Languages Supported
					</div>
					<div className="text-center text-base text-gray-DEFAULT-400">
						Publish pages in 40+ languages to reach global audiences
					</div>
				</div>
				<div className="card-bg flex w-full flex-col gap-4 rounded-lg px-4 py-10">
					<img
						src="/images/landingpage/shopifyLogo1.svg"
						className="mx-auto w-full max-w-[65px]"
						alt="DropshippingDirect Import To Shopify Store"
						width="65"
						height="65"
					/>
					<div className="mx-auto max-w-[225px] text-center font-bold text-white sm:text-xl">
						Direct Import To Shopify Store
					</div>
					<div className="text-center text-base text-gray-DEFAULT-400">
						Import pages into your Shopify store with just a few clicks.
					</div>
				</div>
				<div className="card-bg flex w-full flex-col gap-4 rounded-lg px-4 py-10">
					<img
						src="/images/landingpage/copywritingLogo1.svg"
						className="mx-auto w-full max-w-[65px]"
						alt="DropshippingAdvanced Copywriting Techniques"
						width="65"
						height="65"
					/>
					<div className="mx-auto max-w-[225px] text-center font-bold text-white sm:text-xl">
						Advanced Copywriting Techniques
					</div>
					<div className="text-center text-base text-gray-DEFAULT-400">
						Create compelling content that makes your products irresistible.
					</div>
				</div>
				<div className="card-bg flex w-full flex-col gap-4 rounded-lg px-4 py-10">
					<img
						src="/images/landingpage/convertingPageLogo1.svg"
						className="mx-auto w-full max-w-[65px]"
						alt="Dropshipping High-Converting Product Page"
						width="65"
						height="65"
					/>
					<div className="mx-auto max-w-[225px] text-center font-bold text-white sm:text-xl">
						High-Converting Product Page
					</div>
					<div className="text-center text-base text-gray-DEFAULT-400">
						Pages are optimized based on the latest CRO strategies.
					</div>
				</div>
			</div>

			<div className="relative z-20 mt-10 flex w-full flex-col items-center justify-center gap-6 lg:mb-10 lg:mt-16">
				<Link
					prefetch="intent"
					className="btn-landing w-full max-w-[600px] flex-col text-center font-semibold"
					to={'/signup'}>
					<div>Start Generate Product Pages Now</div>
					<div>100% FREE</div>
				</Link>
				<div className="text-center text-gray-DEFAULT-400">No credit card required</div>
			</div>

			<div className="mx-auto mt-6 flex w-full max-w-[600px] flex-col items-center justify-center rounded-2xl px-4 pb-4 lg:gap-2">
				<div className="flex pb-2 pt-2 lg:pb-0 lg:pt-0">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						className="h-5 w-5 text-[#FFA132]">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						className="h-5 w-5 text-[#FFA132]">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						className="h-5 w-5 text-[#FFA132]">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						className="h-5 w-5 text-[#FFA132]">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						className="h-5 w-5 text-[#FFA132]">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
					</svg>
				</div>
				<p className="max-w-lg pb-2 text-center text-base/7 text-white lg:pb-0">
					"I was able to launch my store within a day and test multiple products quickly while my competitors are still
					working on their website. Best AI Shopify store builder."
				</p>
				<p className="text-center text-base text-gray-DEFAULT-400">Vinish P.</p>
			</div>
		</section>
	);
};

export default KeyBenefitsTwo;
